import React from 'react';
import 'twin.macro';
import { Navigate, useLocation } from 'react-router-dom';
import useIsMobile from 'components/ResponsiveSwitcher/useIsMobile';
import { Sidebar } from './Sidebar';
import TwoColumnsCardSidebar from 'components/TwoColumnsCardSidebar';

export function RedirectAccountSettingsOrMobileMenu() {
  const { search } = useLocation();
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <TwoColumnsCardSidebar tw="pt-6">
        <Sidebar />
      </TwoColumnsCardSidebar>
    );
  }

  return <Navigate to={{ pathname: 'account', search }} replace />;
}
